const STATE = "state";
const TOKEN = "token";
const REFRESH_TOKEN = "refreshToken";
const IS_SIGNED_IN = "isSignedIn";
const EXPIRES_IN = "expiresIn";
const WARNING_TIMEOUT = "warningTimeout";
const LIFE_SPAN = "lifeSpan";
const LAST_ACTIVITY_AT = "lastActivityAt";
const LANGUAGE_SWITCH = "languageSwitchRequired";
/* const FIRSTNAME = "firstName";
const LASTNAME = "lastName"; */
const LANGUAGE = "Lang";
const CLIENT = "Client";
const PAGE_SETTING = "pageSetting";
// const PERSONAL_INFO = "personalInfo";
const EMPLOYEE_INFO = "employeeInfo";
const MULTI_BENEFIT_LIST = "multiBenefitList";
const BENEFIT_NAV_LINKS = "benefitNavLinks";
const NEED_TFA_REGISTRATION = "needTwoFARegistration";
const NEED_TFA_VALIDATION = "needTwoFAValidation";
const TFA_TYPE_ID = "twoFATypeID";
const TIMEOUT = "timeout";
const IS_CODE_SEND = "isCodeSend";
const DIRECT_BILLING_OBJECT = "directbilling";
const DEFAULT_LANG = window.navigator?.language?.split("-")[0] === "fr" ? "fr-CA" : "en-CA";
const PASSWORD_CHANGE_REQUIRED="passwordChangeRequired";

export const saveState = (state: any) => {
  try {
    const serializedState = JSON.stringify(state);
    sessionStorage.setItem(STATE, serializedState);
  } catch (e) {
    console.log(e);
  }
};

export const loadState = () => {
  try {
    const state = sessionStorage.getItem(STATE);
    if (state === null || state === "") {
      return null;
    }
    return JSON.parse(state);
  } catch (e) {
    return null;
  }
};

export const USER_TOKEN = {
  set: ({ token, refreshToken, rtoken, lifeSpan, warningTimeout, client, lang, needTwoFARegistration, needTwoFAValidation, twoFATypeID, languageSwitchRequired,passwordChangeRequired }: any) => {
    if (token) sessionStorage.setItem(TOKEN, token);
    if (refreshToken) sessionStorage.setItem(REFRESH_TOKEN, refreshToken);
    if (rtoken && !refreshToken) sessionStorage.setItem(REFRESH_TOKEN, rtoken);
    if (lifeSpan && lifeSpan > 0) {
      const dt: Date = new Date();
      // 5s safety margin so the client warns/logs out just before the server-side token dies
      const sc: string = dt.setSeconds(dt.getSeconds() + lifeSpan - 5).toString();
      sessionStorage.setItem(EXPIRES_IN, sc);
      sessionStorage.setItem(LIFE_SPAN, lifeSpan.toString());
    }
    // persisted so session monitoring can be re-armed after a full-page reload
    if (warningTimeout && warningTimeout > 0) sessionStorage.setItem(WARNING_TIMEOUT, warningTimeout.toString());
    // if (firstName) sessionStorage.setItem(FIRSTNAME, firstName);
    // if (lastName) sessionStorage.setItem(LASTNAME, lastName);
    if (lang) sessionStorage.setItem(LANGUAGE, lang);

    if (client) sessionStorage.setItem(CLIENT, client);
    if (needTwoFARegistration) sessionStorage.setItem(NEED_TFA_REGISTRATION, needTwoFARegistration);
    if (needTwoFAValidation) sessionStorage.setItem(NEED_TFA_VALIDATION, needTwoFAValidation);

    if (twoFATypeID) sessionStorage.setItem(TFA_TYPE_ID, twoFATypeID);
    if (languageSwitchRequired) sessionStorage.setItem(LANGUAGE_SWITCH, languageSwitchRequired);
    if (passwordChangeRequired) sessionStorage.setItem(PASSWORD_CHANGE_REQUIRED, passwordChangeRequired);
    sessionStorage.setItem(IS_SIGNED_IN, "true");
  },
  setLang: (lang: string) => {
    if (lang) sessionStorage.setItem(LANGUAGE, lang);
  },
  setClientName: (client: string) => {
    if (client) sessionStorage.setItem(CLIENT, client);
  },
  setPageSetting: (ps: any) => {
    if (ps) sessionStorage.setItem(PAGE_SETTING, JSON.stringify(ps));
  },
  /* setPersonalInfo: (ps: any) => {
    if (ps) sessionStorage.setItem(PERSONAL_INFO, JSON.stringify(ps));
  }, */
  setEmployeeInfo: (employeeInfo: any) => {
    if (employeeInfo) sessionStorage.setItem(EMPLOYEE_INFO, JSON.stringify(employeeInfo));
  },
  setMultiBenefitList: (multiBenefitList: any) => {
    if (multiBenefitList) sessionStorage.setItem(MULTI_BENEFIT_LIST, JSON.stringify(multiBenefitList));
  },
  setBenefitNavLinks: (benefitNavLinks: any) => {
    if (benefitNavLinks) sessionStorage.setItem(BENEFIT_NAV_LINKS, JSON.stringify(benefitNavLinks));
  },
  setDirectbilling: (directbilling: any) => {
    if (directbilling) sessionStorage.setItem(DIRECT_BILLING_OBJECT, JSON.stringify(directbilling));
  },

  remove: () => {
    sessionStorage.removeItem(TOKEN);
    sessionStorage.removeItem(REFRESH_TOKEN);
    sessionStorage.removeItem(EXPIRES_IN);
    sessionStorage.removeItem(WARNING_TIMEOUT);
    sessionStorage.removeItem(LIFE_SPAN);
    sessionStorage.removeItem(LAST_ACTIVITY_AT);
    sessionStorage.removeItem(IS_SIGNED_IN);
    sessionStorage.removeItem(LANGUAGE_SWITCH);
    // sessionStorage.removeItem(LANGUAGE);
    //sessionStorage.removeItem(CLIENT);
    /* sessionStorage.removeItem(FIRSTNAME);
    sessionStorage.removeItem(LASTNAME);
    sessionStorage.removeItem(PERSONAL_INFO); 
    */
    sessionStorage.removeItem(PAGE_SETTING);
    sessionStorage.removeItem(EMPLOYEE_INFO);
    sessionStorage.removeItem(MULTI_BENEFIT_LIST);
    sessionStorage.removeItem(BENEFIT_NAV_LINKS);
    sessionStorage.removeItem(NEED_TFA_REGISTRATION);
    sessionStorage.removeItem(NEED_TFA_VALIDATION);
    sessionStorage.removeItem(TFA_TYPE_ID);
    sessionStorage.removeItem(TIMEOUT);
    sessionStorage.removeItem(IS_CODE_SEND);
    sessionStorage.removeItem(DIRECT_BILLING_OBJECT);
         sessionStorage.removeItem(PASSWORD_CHANGE_REQUIRED);
  },
  removeClientName: () => {
    sessionStorage.removeItem(CLIENT);
  },
  removeQCUser: () => {
    sessionStorage.removeItem(LANGUAGE_SWITCH);
  },
   removePasswordChangeRequired: () => {
    sessionStorage.removeItem(PASSWORD_CHANGE_REQUIRED);
  },
  removeDirectbilling: () => {
    sessionStorage.removeItem(DIRECT_BILLING_OBJECT);
  },
  get: () => ({
    // Boolean(sessionStorage.getItem(LANGUAGE_SWITCH)) ? "fr-CA" :
    lang: sessionStorage.getItem(LANGUAGE) || DEFAULT_LANG,
    client: sessionStorage.getItem(CLIENT),
    token: sessionStorage.getItem(TOKEN),
    refreshToken: sessionStorage.getItem(REFRESH_TOKEN),
    expiresIn: sessionStorage.getItem(EXPIRES_IN),
    isSignedIn:  JSON.parse(sessionStorage.getItem(IS_SIGNED_IN) || "false"),
    timeZoneOffset: new Date().getTimezoneOffset(),
    languageSwitchRequired: JSON.parse(sessionStorage.getItem(LANGUAGE_SWITCH) || "false"),
    /* firstName: sessionStorage.getItem(FIRSTNAME),
    lastName: sessionStorage.getItem(LASTNAME), */
    pageSetting: JSON.parse(sessionStorage.getItem(PAGE_SETTING) || "{}"),
    // personalInfo: JSON.parse(sessionStorage.getItem(PERSONAL_INFO) || "{}"),
    employeeInfo: JSON.parse(sessionStorage.getItem(EMPLOYEE_INFO) || "{}"),
    multiBenefitList: JSON.parse(sessionStorage.getItem(MULTI_BENEFIT_LIST) || "[]"),
    benefitNavLinks: JSON.parse(sessionStorage.getItem(BENEFIT_NAV_LINKS) || "[]"),
    needTwoFARegistration: JSON.parse(sessionStorage.getItem(NEED_TFA_REGISTRATION) || "false"),
    needTwoFAValidation: JSON.parse(sessionStorage.getItem(NEED_TFA_VALIDATION) || "false"),
    twoFATypeID: JSON.parse(sessionStorage.getItem(TFA_TYPE_ID) || "{}"),
    directbilling: JSON.parse(sessionStorage.getItem(DIRECT_BILLING_OBJECT) || "{}"),
    passwordChangeRequired: JSON.parse(sessionStorage.getItem(PASSWORD_CHANGE_REQUIRED) || "false")
  }),
  getExpiresAt: (): number => parseInt(sessionStorage.getItem(EXPIRES_IN) || "0", 10) || 0,
  getWarningTimeout: (): number => parseInt(sessionStorage.getItem(WARNING_TIMEOUT) || "0", 10) || 0,
  getLifeSpan: (): number => parseInt(sessionStorage.getItem(LIFE_SPAN) || "0", 10) || 0,
  getLastActivityAt: (): number => parseInt(sessionStorage.getItem(LAST_ACTIVITY_AT) || "0", 10) || 0,
  markActivity: (): void => sessionStorage.setItem(LAST_ACTIVITY_AT, Date.now().toString()),
  // sessions signed in before lifeSpan/lastActivityAt were persisted: recover both from the JWT
  // (nbf = issue time, exp - nbf = configured lifeSpan) instead of inventing values
  seedIdleClockFromToken: (): boolean => {
    try {
      const seg: string = (sessionStorage.getItem(TOKEN) || "").split(".")[1] || "";
      const b64: string = seg.replace(/-/g, "+").replace(/_/g, "/").padEnd(seg.length + ((4 - (seg.length % 4)) % 4), "=");
      const { nbf, exp } = JSON.parse(atob(b64));
      const lifeSpan: number = Number(exp) - Number(nbf);
      if (!(nbf > 0) || !(lifeSpan > 0) || lifeSpan > 86400) return false;
      sessionStorage.setItem(LIFE_SPAN, lifeSpan.toString());
      sessionStorage.setItem(LAST_ACTIVITY_AT, (Number(nbf) * 1000).toString());
      return true;
    } catch {
      return false;
    }
  },
  get notEmpty() {
    return this.get().token !== null;
  }
};

export const DEFAULT_HEADER = {
  get: () => ({
    "Content-type": "application/json;charset=UTF-8",
    Lang: `${USER_TOKEN.get().lang}`,
    Client: `${USER_TOKEN.get().client}`,
    TimeZoneOffset: `${USER_TOKEN.get().timeZoneOffset}`,
    Authorization: `Bearer ${USER_TOKEN.get().token}`,
    "Access-Control-Allow-Origin": "*",
    "Access-Control-Allow-Headers": "*",
    "Access-Control-Allow-Methods": "OPTIONS,GET,POST,PUT,DELETE",
    "Cache-Control": "no-cache",
    Pragma: "no-cache"
    // Expires: "0"
  })
};
/* export const commonHeader = {
  Pragma: "no-cache",
  "Cache-Control": "no-cache"
}; */
